import * as React from 'react';
import { TableCell, TableRow } from '@telia-front/table';
import PacketTableCell from './packet-table-cell';
const DesktopTableHeader = (props) => {
    const { packets } = props;
    return (React.createElement(TableRow, { background: "neutral-1" },
        React.createElement(TableCell, { type: "th", width: packets.length <= 1 ? 4 : 3, scope: "col" }),
        packets.map((packet, index) => (React.createElement(PacketTableCell, { packet: packet, width: packets.length <= 1 ? 2 : 3, key: index })))));
};
export default DesktopTableHeader;
